import { API } from '@/api/api';
import { loggerTime } from '~/utils/loggerTime';
import { useGlobalStore } from '~/stores/global';
import type { RegionInApp } from '~/interfaces/app';

import type { RequestParams } from '~/interfaces/api';

export async function _getPageEnvironment(params: RequestParams) {
  const globalStore = useGlobalStore();
  try {
    const controller = new AbortController();
    if (!import.meta.env.SSR) {
      globalStore.setCancelToken(controller);
    }
    const isShowConsole =
      typeof import.meta.env.VITE_VIEW_LOG_TIME !== 'undefined' &&
      import.meta.env.VITE_VIEW_LOG_TIME === 'true';
    if (isShowConsole) {
      const res = await loggerTime(
        API.get('/site/page_lookup', {
          params,
          signal: controller.signal,
        }),
        'pageLookup: '
      );
      return res[0];
    } else {
      return await API.get('/site/page_lookup', {
        params,
        signal: controller.signal,
      });
    }
  } catch (error: ErrorEvent | any) {
    const notFoundCodes = [404, 410, 412];
    if (
      error?.response?.status ??
      notFoundCodes.includes(error?.response?.status)
    ) {
      throw showError({ statusCode: 404 });
    }
    return undefined;
  }
}

export async function _initCatalog() {
  try {
    const res = await API.get('/site/catalog');
    return res.data;
  } catch (error) {
    // console.error('initCatalog error');
  }
}

export async function _fetchRegion(
  id: number
): Promise<RegionInApp | undefined> {
  try {
    const res = await API.get(`/regions/${id}`);
    return res.data;
  } catch (error) {
    // console.error('fetchRegion error', error);
    return undefined;
  }
}
